import Icon from "./IconBase.js";
const ArrowUpRightBlack = (props) => {
  return (
    <Icon width="24" height="24" viewBox="0 0 20 20" {...props}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4.66602 11.3334L11.3327 4.66675"
          stroke="#0F0F0F"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.66602 4.66675H11.3327V11.3334"
          stroke="#0F0F0F"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </Icon>
  );
};
export default ArrowUpRightBlack;
